__turbopack_context__.v({
  "accordion": "LayoutAccordion-module__Gwq9Ca__accordion",
  "accordionIcon": "LayoutAccordion-module__Gwq9Ca__accordionIcon",
  "accordionItem": "LayoutAccordion-module__Gwq9Ca__accordionItem",
  "accordionSummary": "LayoutAccordion-module__Gwq9Ca__accordionSummary",
  "closing": "LayoutAccordion-module__Gwq9Ca__closing",
  "content": "LayoutAccordion-module__Gwq9Ca__content",
  "open": "LayoutAccordion-module__Gwq9Ca__open",
  "wrapper": "LayoutAccordion-module__Gwq9Ca__wrapper",
});
